export enum FacebookFormButtonType {
    NONE = 0,
    View_Website = 1,
    Download = 2,
    Call_Business = 3,
}